import enquire from 'enquire.js/dist/enquire.min';
/**
 * quotes-with-background
 */
// run js depends on the screen size
enquire.register('screen and (max-width: 767px)', {
    match: function () {
        $('.s-quotes-with-background__carousel-item-inner').removeClass('text-color-light');
        $('.s-quotes-with-background__row').removeClass('section--bg-img');
    },
    unmatch: function () {
        $('.s-quotes-with-background__carousel-item-inner').addClass('text-color-light');
        $('.s-quotes-with-background__row').addClass('section--bg-img');
    },
});



// WEBPACK FOOTER //
// ./scripts/routes/sections/quotes-with-background.js